module.exports = __webpack_public_path__ + "assets/img/49157b54d586abb0383901b06382d098.svg";